import Vue from 'vue'
import App from './app/App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import './main.scss'
Vue.config.productionTip = false
import VueClipboard from 'vue-clipboard2'
import './components/components-define'
import store from './store'
import './assets/css/style.css'
import HttpService from './services/base/HttpService'
import StorageConfig from './services/config/StorageConfig'
import Vuelidate from "vuelidate";

if (StorageConfig.getToken()) {
  HttpService.setHeader()
}

Vue.use(VueClipboard)
Vue.use(Vuelidate)
new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')

